type RetrieveMilestoneError = {
  notFound: boolean;
};

const retrieveMilestoneError: RetrieveMilestoneError = {
  notFound: false,
};

export type { RetrieveMilestoneError };

export { retrieveMilestoneError };
